/* ==========================================================================
   HOME PASSION · BAGLANTI GUVENCESI (son savunma hatti)

   Amac: bir urun karti tiklandiginda urun sayfasinin ACILDIGINDAN emin olmak.
   Baska bir betik ya da magazadaki bir uygulama click olayini yutarsa bu
   katman devreye girer ve gezinmeyi kendisi yapar.

   Calisma mantigi:
   - pointerdown ile pointerup arasindaki mesafe olculur
   - 8 pikselden az ise bu bir TIKLAMADIR, surukleme degil
   - 160ms beklenir; tarayici zaten gezindiyse hicbir sey yapilmaz
   - gezinmemisse baglanti elle acilir
   Fare ve dokunmatikte ayni sekilde calisir.

   NOT 1: burada bilerek document.hidden kontrolu YOK. Onceki surumde vardi ve
          arka plandaki sekmede gezinmeyi engelliyordu.
   NOT 2: SKIP listesi kritik. Kart yapisi soyle:
            a.hp-pc-img > span.hp-pc-qv (hizli bakis) + button.hp-pc-add
          Yani hizli bakis ve sepete ekme BAGLANTININ ICINDE. Bunlara
          basildiginda urun sayfasina gitmemeli.
   ========================================================================== */
(function(){
  'use strict';
  if(window.__hpLinkGuard) return;   /* hp-assets her bolumde render edildigi
                                        icin bu dosya sayfa basina birden cok
                                        kez calisabilir — tek sefere indir */
  window.__hpLinkGuard = 1;

  var SEC  = '.hp-crsl-in, .hp-crsl-vp, .hp-vcat-vp, .hp-vid-vp, .hp-grid, .hp-duo, .hp-col-grid, .hp-pc, .hp-dc';
  var SKIP = 'button, input, select, textarea, form, label,'
           + '.hp-pc-qv, .hp-pc-add, .hp-pc-heart, .hp-size, .hp-swatch,'
           + '.hp-fav, .hp-qa, .hp-quick, [data-vadd]';
  var sa=null, sx=0, sy=0, st=0;

  function anchorOf(el){
    if(!el || !el.closest) return null;
    var a = el.closest('a[href]');
    if(!a) return null;
    if(a.getAttribute('target') === '_blank') return null;
    var h = a.getAttribute('href') || '';
    if(!h || h.charAt(0) === '#') return null;
    if(/^(mailto:|tel:|javascript:)/i.test(h)) return null;
    if(h.charAt(0) !== '/' && h.indexOf(location.origin) !== 0) return null;
    return a;
  }

  document.addEventListener('pointerdown', function(e){
    sa = null;
    if(!e.target || !e.target.closest) return;
    if(e.target.closest(SKIP)) return;
    if(!e.target.closest(SEC)) return;
    var a = anchorOf(e.target);
    if(!a) return;
    sa = a; sx = e.clientX; sy = e.clientY; st = Date.now();
  }, true);

  document.addEventListener('pointerup', function(e){
    if(!sa) return;
    var a = sa; sa = null;
    if(e.target && e.target.closest && e.target.closest(SKIP)) return;
    if(Math.abs(e.clientX - sx) > 8 || Math.abs(e.clientY - sy) > 8) return;  /* suruklendi */
    if(Date.now() - st > 900) return;                                        /* uzun basma */
    if(e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;             /* yeni sekme */

    var href = a.href, was = location.href;
    setTimeout(function(){
      if(location.href === was){ location.href = href; }
    }, 160);
  }, true);
})();
